import ApiService from '../services/apiService';
import { mapState, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import { themeColors } from '../utils/themes';
export default {
  name: 'ViewUserProfile',
  data: function () {
    return {
      colors: themeColors,
      mapStyles: [{
        text: 'niotix',
        value: '1'
      }, {
        text: 'Satellite',
        value: '2'
      }, {
        text: 'Streets',
        value: '3'
      }, {
        text: 'Combo',
        value: '4'
      }],
      showAddressData: false,
      addressPanel: null,
      contactPanel: null,
      buttons01: [{
        title: this.$i18n_t('Common.save'),
        dataCy: 'btn_save_profile',
        icon: 'fas fa-save',
        action: 'saveUserProfile',
        valid: true
      }],
      buttons02: [{
        title: this.$i18n_t('accMgmt.user.changePassword'),
        dataCy: 'btn_save_password',
        icon: 'fas fa-save',
        action: 'handlePwdUpdate',
        valid: true
      }],
      userObject: {
        properties: {
          address: {
            street: null,
            houseNumber: null,
            postalCode: null,
            city: null,
            region: null,
            country: null
          },
          contactInfo: {
            phone: null,
            mobile: null
          },
          userDefaults: {
            color: 'niotix',
            language: 'en',
            mapLayout: '',
            uiTheme: false,
            drawer: true,
            miniVariant: false,
            map3DBuild: false,
            pagination: 10
          }
        }
      },
      mfaDialog: false,
      mfaDialogDisable: false,
      mfaEnabled: false,
      valid: false,
      valid2: false,
      password1: '',
      password2: '',
      pwOld: '',
      passwordPolicy: {},
      passwordError: null,
      emailRules: [v => !!v || this.$i18n_t('Common.fieldRequired'), v => /.+@.+\..+/.test(v) || this.$i18n_t('Common.emailValid')],
      reqRules: [v => !!v || this.$i18n_t('Common.fieldRequired')]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'drawer', 'UiTheme', 'map3DBuild', 'language', 'themes', 'miniVariant', 'color', 'colorHexLight', 'colorHexDark', 'userSelectedItemsPerList', 'load', 'loading']),
    ...mapState('authentication', ['user', 'isImpersonating']),
    hasCustomColor() {
      return this.UiTheme ? this.colorHexDark : this.colorHexLight;
    },
    passwordIsValid() {
      return this.password1 === this.password2;
    },
    passwordHasError() {
      return this.passwordError && typeof this.passwordError === 'string';
    },
    /*password2Rules() {
      return [(v) => (!!v && v === this.password1) || this.$i18n_t('accMgmt.user.pwdMissmatch')];
    },
    passwordRules() {
      return [
        (v) => !!v || this.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED'),
        // validatePassword returns a promise, but this rules-method must return a string or bool
        // so just perform a typecheck to "convert" into boolean
        (v) => (!!v && typeof this.validatePassword() === 'string') || true,
      ];
    },*/
    userPrimaryTenantId() {
      return get(get(this.userObject, 'access', []).filter(a => a.primary), '[0].tenantId');
    },
    passwordRules() {
      return {
        passNew: v => {
          return !!v || this.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED');
        },
        passRepeat: v => {
          return v === this.password1 || this.$i18n_t('accMgmt.user.pwdMissmatch');
        }
      };
    }
  },
  mounted() {
    return ApiService.getUser(this).then(user => {
      this.userObject = user;
      if (!this.userObject.properties) {
        this.$set(this.userObject, 'properties', {});
      }
      if (!this.userObject.properties.address) {
        this.$set(this.userObject.properties, 'address', {});
      }
      if (!this.userObject.properties.contactInfo) {
        this.$set(this.userObject.properties, 'contactInfo', {});
      }
      if (!this.userObject.properties.userDefaults) {
        this.$set(this.userObject.properties, 'userDefaults', {
          color: 'niotix',
          language: 'en',
          mapLayout: '',
          uiTheme: false,
          drawer: true,
          miniVariant: false,
          map3DBuild: false,
          pagination: 10
        });
      }
      this.mfaEnabled = get(this.userObject, 'properties.2fa.enabled', false);
      return ApiService.tenantGetPasswordPolicy(this.userPrimaryTenantId);
    }).then(passwordPolicy => {
      this.passwordPolicy = passwordPolicy;
    }).catch(error => {
      if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
        this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
      } else {
        this.$snack('Failed to load User', 'error');
      }
    }).finally(() => {
      this.$store.state.app.loading = false;
    });
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    validate(form) {
      if (this.$refs[form].validate()) {
        this.snackbar = true;
      }
    },
    handleSubmit() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.validate('userForm');
      ApiService.updateUser(this.userObject).then(user => {
        this.userObject = user.data;
        this.setLang();
        this.setColor();
        this.setMapStyle();
        this.setUiTheme();
        this.$store.state.app.drawer = this.userObject.properties.userDefaults.drawer;
        this.$store.state.app.miniVariant = this.userObject.properties.userDefaults.miniVariant;
        this.$store.state.app.map3DBuild = this.userObject.properties.userDefaults.map3DBuild;
        localStorage.setItem('userSelectedItemsPerList', this.userObject.properties.userDefaults.pagination);
        this.$snack(this.$i18n_t('Common.userUpdated'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.userUpdatedFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    setLang() {
      this.$store.commit('app/language', {
        payload: this.userObject.properties.userDefaults.language,
        context: this
      });
    },
    setColor() {
      this.$store.state.app.color = this.userObject.properties.userDefaults.color;
      localStorage.setItem('thingshiveColorDark', this.$store.state.app.color);
      localStorage.setItem('thingshiveColorLight', this.$store.state.app.color);
    },
    setMapStyle() {
      localStorage.setItem('mapStyle', this.userObject.properties.userDefaults.mapLayout);
      this.$store.state.app.mapStyle = this.userObject.properties.userDefaults.mapLayout;
    },
    setUiTheme() {
      const mode = this.userObject.properties.userDefaults.uiTheme ? 'dark' : 'light';
      const userHighlight = mode === 'dark' ? localStorage.getItem('thingshiveColorDark') : localStorage.getItem('thingshiveColorLight');
      localStorage.setItem('thingshiveTheme', mode);
      this.$store.state.app.color = userHighlight || this.themes[mode].highlight;
      this.$store.state.app.mode = mode;
      this.$store.state.app.UiTheme = mode === 'dark';
      this.$vuetify.theme.dark = this.userObject.properties.userDefaults.uiTheme;
    },
    handlePwdUpdate() {
      this.validate('passwordForm');
      this.updatePassword();
    },
    validatePassword: debounce(function () {
      return ApiService.validateUserPassword(this.password1, this.userPrimaryTenantId).then(result => {
        if (typeof result === 'string') {
          const matches = result.match(/(.+?)_([0-9]+)$/);
          // special handling: length is encoded in error-message
          if (matches && matches.length) {
            let length = parseInt(matches[2]);
            let message = matches[1];
            this.passwordError = this.$i18n_tc(`accMgmt.user.passwordErrors.${message}`, length, {
              n: length
            });
          } else {
            this.passwordError = this.$i18n_t(`accMgmt.user.passwordErrors.${result}`);
          }
        } else {
          this.passwordError = null;
        }
      });
    }, 250),
    updatePassword() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.submitted = true;
      if (!this.passwordIsValid) {
        this.$snack(this.$i18n_t('accMgmt.user.pwdMissmatch'), 'error');
        return;
      }
      return ApiService.updatePassword(this.userObject.id, this.pwOld, this.password1).then(() => {
        this.$snack(this.$i18n_t('accMgmt.user.pwdChgSuccess'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          if (error.response.data.statusCode === 400) {
            this.$snack(this.$i18n_t('accMgmt.user.pwdChgFailSame'), 'error');
          } else {
            this.$snack(this.$i18n_t('accMgmt.user.pwdChgFail'), 'error');
          }
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    },
    saveUserProfile() {
      this.handleSubmit();
    },
    handleToggle2fa() {
      if (this.mfaEnabled) {
        this.mfaDialogDisable = true;
        this.mfaDialog = false;
      } else {
        this.mfaDialog = true;
        this.mfaDialogDisable = false;
      }
    },
    resetValidate() {
      this.$refs.passwordForm.resetValidation();
      this.passwordError = null;
    }
  }
};